import paper from 'paper';
import * as TweenMax from 'gsap/umd/TweenMax';
import Circ from 'gsap/umd/EasePack';

export default class PaperSetup {

    init(state, canvas, threeCanvas, blueTriangle, setup, duration, delay) {
        this.time = 0;

        this.initState = state;
        this.lastState = this.initState;

        this.canvas = canvas;
        this.threeCanvas = threeCanvas;
        this.blueTriangle = blueTriangle;

        this.setup = setup;
        this.texture = this.setup.threeScene.texture;
        paper.setup(this.canvas);

        this.initDuration = duration;
        this.initDelay = delay;
        this.lastPath = 0;

        // Manually rendering when necessary
        paper.view.autoUpdate = false;

        // The main visible item
        this.mainItem = new paper.Group();
        // contains the diagonal shape
        this.mainItemClipped = new paper.Group();
        // A shape holder for smooth transitions
        this.mainItemHolder = new paper.Group();

        this.mainPath = new paper.Path();
        this.mainPathHolder = new paper.Path();
        this.mainPathClipped = new paper.Path();

        // contains all the colors, for transitions
        this.fillColors = [
            ['#E9609B',
                '#E9609B', '#E9609B', '#E9609B'],
            ['#9C9C9C',
                '#9C9C9C', '#9C9C9C', '#9C9C9C'],
            ['#FFDD00',
                '#FFDD00', '#FFDD00', '#FFDD00'],
            ['#E9609B',
                '#E9609B', '#E9609B', '#E9609B'],
            ['#66B678',
                '#66B678', '#66B678', '#66B678'],
            ['#BDB560',
                '#BDB560', '#BDB560', '#BDB560'],
            ['#00B6E8',
                '#00B6E8', '#00B6E8', '#00B6E8'],
            ['#EE824F',
                '#EE824F', '#EE824F', '#EE824F'],
            ['#E9609B', '#FFDD00', '#66B678', '#00B6E8'],
        ];
        // holder for smooth color transitions
        this.fillColorsHolder = this.fillColors[this.initState];

        // Drawing of the diagonal shape
        this.triangle = new paper.Path();
        this.triangle.add(new paper.Point(0, 0));
        this.triangle.add(new paper.Point(paper.view.bounds.right, paper.view.bounds.bottom));
        this.triangle.add(new paper.Point(0, paper.view.bounds.bottom));

        if (this.initState === 0) {
            this.triangle.fillColor = '#ffffff';
        } else {
            this.triangle.fillColor = '#ffffff';
        }

        this.loadShapes();
        this.stateHandler();
    }

    stateHandler() {
        // this.lastState = 0;
        this.interState = 0;
        // this.lastPath = 0;
    }

    // stateHandler() {
    //     this.lastState = 0;
    //
    //     this.shapeDuration = 0.75;
    //     this.colorDuration = 0.5;
    //     this.interState = 0;
    // }

    transition(i, duration, delay) {
        // console.log(this.mainPathHolder, this.paths[this.lastPath],
        // this.interState);
        this.mainPathHolder.interpolate(this.mainPathHolder, this.paths[this.lastPath], this.interState);

        TweenMax.killAll();

        this.setup.threeScene.shaderTransition(1, duration, delay);

        const val = {
            factor: 0, triangleColor: this.triangle.fillColor.toCSS(true), color0: this.fillColorsHolder[0], color1: this.fillColorsHolder[1], color2: this.fillColorsHolder[2], color3: this.fillColorsHolder[3],
        };

        const triangleFill = '#ffffff';

        this.randomPath = Math.floor(Math.random() * this.paths.length);

        for (let i = 1; i <= 20; i++) {
            this.randomPath = Math.floor(Math.random() * this.paths.length);
            if (this.randomPath !== this.lastPath) {
                break;
            }
        }

        // if (i === 0) {
        //     triangleFill = '#ffffff';
        // } else {
        //     triangleFill = '#000000';
        // }

        TweenMax.to(val, duration, {
            factor: 1,
            delay,
        }).eventCallback('onUpdate', () => {
            this.mainPath.interpolate(this.mainPathHolder, this.paths[this.randomPath], val.factor);
            this.mainPathClipped.interpolate(this.mainPathHolder, this.paths[this.randomPath], val.factor);
            this.render();
            this.interState = val.factor;
        });

        TweenMax.to(val, duration / 1.5, {
            // factor: 1,
            delay,
            triangleColor: triangleFill,
            color0: this.fillColors[i][0],
            color1: this.fillColors[i][1],
            color2: this.fillColors[i][2],
            color3: this.fillColors[i][3],
            // ease: Elastic.easeOut
        }).eventCallback('onUpdate', () => {
            this.fillColorsHolder = [val.color0, val.color1, val.color2, val.color3];
            this.mainPath.fillColor = {
                gradient: {
                    stops: this.fillColorsHolder,
                },
                origin: new paper.Point(paper.view.bounds.left, paper.view.bounds.top),
                destination: new paper.Point(paper.view.bounds.right, paper.view.bounds.bottom),
            };

            // this.backgroundColor.fillColor = val.backgroundColor;
            this.triangle.fillColor = val.triangleColor;
            this.render();
        });

        this.lastState = i;
        this.lastPath = this.randomPath;
    }

    transitionFirst(duration, delay = 0) {
        // Abort if we're already on the
        if (this.interState === 0) return;

        this.mainPathHolder.interpolate(this.mainPathHolder, this.paths[this.lastPath], this.interState);

        TweenMax.killAll();

        this.setup.threeScene.shaderTransition(1, duration, delay);

        const val = {
            factor: 0, triangleColor: this.triangle.fillColor.toCSS(true), color0: this.fillColorsHolder[0], color1: this.fillColorsHolder[1], color2: this.fillColorsHolder[2], color3: this.fillColorsHolder[3],
        };

        const triangleFill = '#ffffff';

        // if (this.lastState === 0) {
        //     triangleFill = '#ffffff';
        // } else {
        //     triangleFill = '#000000';
        // }

        TweenMax.to(val, duration, {
            factor: 1,
            delay,
        }).eventCallback('onUpdate', () => {
            this.mainPath.interpolate(this.mainPathHolder, this.paths[0], val.factor);
            this.mainPathClipped.interpolate(this.mainPathHolder, this.paths[0], val.factor);
            this.render();
            this.interState = val.factor;
        });

        TweenMax.to(val, duration / 1.5, {
            // factor: 1,
            delay,
            triangleColor: triangleFill,
            color0: this.fillColors[this.lastState][0],
            color1: this.fillColors[this.lastState][1],
            color2: this.fillColors[this.lastState][2],
            color3: this.fillColors[this.lastState][3],
            // ease: Elastic.easeOut
        }).eventCallback('onUpdate', () => {
            this.fillColorsHolder = [val.color0, val.color1, val.color2, val.color3];
            this.mainPath.fillColor = {
                gradient: {
                    stops: this.fillColorsHolder,
                },
                origin: new paper.Point(paper.view.bounds.left, paper.view.bounds.top),
                destination: new paper.Point(paper.view.bounds.right, paper.view.bounds.bottom),
            };

            // this.backgroundColor.fillColor = val.backgroundColor;
            this.triangle.fillColor = val.triangleColor;
            this.render();
        });

        this.lastPath = 0;
    }

    render() {
        this.time++;

        // skipping a frame to speed up rendering
        if (this.time % 2 === 0) {
            paper.view.update();
            this.texture.needsUpdate = true;
        }
    }

    onWindowResize() {
        this.item.position = paper.view.center;
        this.item.fitBounds(paper.view.bounds);
        this.item.scale(0.97);

        this.triangle.position = paper.view.center;
        this.triangle.fitBounds(paper.view.bounds);
    }

    loadShapes() {
        this.paths = [];

        paper.project.importSVG('/build/images/home/shapes.svg', (item) => {
            this.item = item;
            this.item.position = paper.view.center;
            this.item.fitBounds(paper.view.bounds);
            this.item.scale(0.97);

            for (let i = 0; i < this.item.children.length; i++) {
                if (this.item.children[i].className === 'Path') {
                    const path = this.item.children[i];
                    path.visible = false;
                    this.paths.push(path);
                }
            }

            // this.mainPathItem = this.item.clone();

            // this.randomPath = Math.floor(Math.random() * this.paths.length);
            this.randomPath = 0;

            this.lastPath = this.randomPath;
            this.mainPath = this.item.children[this.randomPath + 1].clone();
            this.mainPathHolder = this.item.children[this.randomPath + 1].clone();
            this.mainPathClipped = this.item.children[this.randomPath + 1].clone();
            this.mainPath.visible = true;
            this.mainPathClipped.visible = true;

            this.mainPath.fillColor = {
                gradient: {
                    stops: this.fillColorsHolder,
                },
                origin: new paper.Point(paper.view.bounds.left, paper.view.bounds.top),
                destination: new paper.Point(paper.view.bounds.right, paper.view.bounds.bottom),
            };

            this.clipping = new paper.Group(this.mainPathClipped, this.triangle);
            this.clipping.clipped = true;

            this.render();

            // setTimeout(()=>{
            //     this.threeCanvas.classList.add('animate');
            // },this.initDelay);
            // TweenMax.killAll();
            // TweenMax.to(this.threeCanvas, this.initDuration, {
            //     opacity: 1,
            //     delay: this.initDelay,
            // });

        });
        this.render();
    }

    triangleIntro() {
        TweenMax.killAll();
        document.body.classList.add('no-overflow');
        TweenMax.to(this.blueTriangle, this.initDuration, {
            opacity: 1,
            delay: this.initDelay,
            onComplete: () => {
                // this.blueTriangle.style.animationPlayState = 'running';
                // this.blueTriangle.style.webkitAnimationPlayState = 'running';
                // this.blueTriangle.style.animationName = 'scaleDownTriangle';
                // this.blueTriangle.style.webkitAnimationName = 'scaleDownTriangle';
                TweenMax.to(this.blueTriangle, 1.75, {
                    scale: 0,
                    delay: 1,
                    ease: Circ.easeOut,
                    onComplete: () => {
                        document.querySelector('.canvasContainers').classList.add('no-overflow');
                        document.body.classList.remove('no-overflow');
                    },
                });
            },
        });
    }

    destroy() {

        TweenMax.killAll();
        // TweenMax.to(this.threeCanvas, duration, {
        //     opacity: 0,
        //     delay,
        // }).eventCallback('onComplete', () => {
        //     return callback();
        // });
    }
}
